export default __webpack_public_path__ + "static/media/icon_awesome_discord.974ac96d.png";